<template>
  <main>
    <router-view />
  </main>
</template>

<script>

export default {
  data () {
    return {
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/index.vue